module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Match Point")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Leigh Carman")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Two stubborn men.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One is a rude jerk. The other, the life of the party.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was hate at first sight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pro beach volleyball players Finn Callahan and Dexter Savage have been rivals since college. While Finn always comes out on top on the court, Dexter’s carefree and fun-loving personality earns him scores of adoring men and women. And as much as Finn fights to deny it, there’s another reason for the tension he feels when Dex is around. Hate wasn’t the only thing he felt when he first laid eyes on his opponent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When they’re forced to team up, the two men must bury their differences—on and off the court—if either of them is going to succeed professionally.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0